export default function ChapterComparison({ members, chapters }) {
  if (!chapters || !members) return null

  if (chapters.length === 0) return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-6">
      <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-4">Chapter Performance Comparison</div>
      <div className="text-gray-400 text-sm">No chapters found</div>
    </div>
  )

  const chapterStats = chapters.map((chapter) => {
    const chapterMembers = members.filter(m => m.chapter_id === chapter.id)
    const active = chapterMembers.filter(m => m.status === 'active').length
    const male = chapterMembers.filter(m => m.gender === 'male').length
    const female = chapterMembers.filter(m => m.gender === 'female').length
    const paid = chapterMembers.filter(m => {
      if (!m.subscriptions || m.subscriptions.length === 0) return false
      const latest = m.subscriptions.sort((a, b) => new Date(b.payment_date) - new Date(a.payment_date))[0]
      return new Date(latest.valid_until) >= new Date()
    }).length
    const collectionRate = chapterMembers.length > 0 ? Math.round((paid / chapterMembers.length) * 100) : 0
    return { name: chapter.name, total: chapterMembers.length, active, male, female, paid, collectionRate }
  }).sort((a, b) => b.total - a.total)

  const maxMembers = Math.max(...chapterStats.map(c => c.total), 1)

  return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-6">
      <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-6">
        Chapter Performance Comparison
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 dark:border-white/10">
              {['Chapter', 'Members', 'Active', 'Male', 'Female', 'Paid', 'Collection Rate', 'Size'].map((h) => (
                <th key={h} className="text-left py-3 px-4 text-xs text-gray-500 uppercase tracking-widest font-semibold whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {chapterStats.map((chapter) => (
              <tr key={chapter.name} className="border-b border-gray-200 dark:border-white/5 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
                <td className="py-3 px-4 font-semibold whitespace-nowrap text-gray-900 dark:text-white">{chapter.name}</td>
                <td className="py-3 px-4 font-black text-green-500 dark:text-green-400">{chapter.total}</td>
                <td className="py-3 px-4 text-gray-500">{chapter.active}</td>
                <td className="py-3 px-4 text-gray-500">{chapter.male}</td>
                <td className="py-3 px-4 text-gray-500">{chapter.female}</td>
                <td className="py-3 px-4 text-gray-500">{chapter.paid}</td>
                <td className="py-3 px-4">
                  <span className={`text-xs font-bold ${
                    chapter.collectionRate >= 75 ? 'text-green-500 dark:text-green-400' :
                    chapter.collectionRate >= 50 ? 'text-yellow-500 dark:text-yellow-400' : 'text-red-500 dark:text-red-400'
                  }`}>
                    {chapter.collectionRate}%
                  </span>
                </td>
                <td className="py-3 px-4 w-32">
                  <div className="bg-gray-200 dark:bg-white/10 h-2">
                    <div className="bg-green-500 h-2" style={{ width: `${(chapter.total / maxMembers) * 100}%` }} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}